import { Avatar } from "@mui/material";
import { BasicProfile } from "protico-sdk";
import React from "react";
import Blockies from "react-blockies";
type Prop = {
  profileData: BasicProfile;
  toDomain: string;
};
const ChatTyping: React.FC<Prop> = ({ profileData, toDomain }) => {
  return (
    <div className="chat-item-message-container">
      <li className="chat-item-messages">
        <div className="d2c-chat-item-user-info" style={{ margin: "0 5px" }}>
          {profileData.avatar_url ? (
            <Avatar
              alt="PFP"
              src={profileData.avatar_url}
              sx={{ width: 25, height: 25 }}
            />
          ) : (
            <Blockies
              seed={toDomain}
              size={10}
              scale={2.5}
              color="#ddd"
              className="identicon"
            />
          )}
        </div>
        <div 
          className="d2c-item-content-container"
          style={{ margin: "8px 0 0 24px" }}>
          <div className="dot-falling" />
        </div>
      </li>
    </div>
  );
};
export default ChatTyping;
